import React, { useEffect, useRef } from "react";
import { drawScene } from "./renderer";
import { FIELD_WIDTH, START_WIDTH } from "./world";

// A short tower with a few cut floors and the next brick sliding in (from the design's card picture).
const OFFSETS = [0, -0.6, 0, 0.5, 0, 0, -0.4, 0.3, 0, -0.5, 0];

function thumbFrame() {
  let x = (FIELD_WIDTH - START_WIDTH) / 2, w = START_WIDTH;
  const floors = [{ x, w }];
  OFFSETS.forEach((d) => {
    const left = Math.max(x + d, x), right = Math.min(x + d + w, x + w);
    x = left;
    w = right - left;
    floors.push({ x, w });
  });
  return { floors, moving: { x: x + 2.4, w }, camera: { bottom: -1.2, zoom: 1.25 }, debris: [] };
}

/** Static picture of a Skyline Stacker tower for the landing card (no game code). */
function TowerThumb({ width, height }: { width: number; height: number }) {
  const canvas = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const cv = canvas.current;
    const ctx = cv?.getContext("2d");
    if (!cv || !ctx) return;
    const dpr = window.devicePixelRatio || 1;
    cv.width = Math.round(width * dpr);
    cv.height = Math.round(height * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    drawScene(ctx, thumbFrame(), width, height);
  }, [width, height]);

  return (
    <div className="tower-thumb">
      <canvas ref={canvas} style={{ width, height, display: "block", borderRadius: 4 }} aria-hidden />
    </div>
  );
}

export default TowerThumb;
